import React from "react"
import Cabecalho from "../Cabecalho"
import { ComponentePrincipal } from "./components/ComponentePrincipal"

export function DadosPedidoFornecedor() {
    return (
        <>
            <Cabecalho pagina="Relatório de Pedidos" />
            <ComponentePrincipal />
        </>
    )
}
